import { Component } from '@angular/core';

@Component({
  selector: 'tangram-branding-settings',
  templateUrl: './branding-settings.component.html',
  styleUrls: ['./branding-settings.component.scss']
})
export class BrandingSettingsComponent {
  bannerFileName = '';
  selectedTheme = 'default';
  themes = [
    { id: 'default', label: 'Default Theme' },
    { id: 'light', label: 'Light Theme' },
    { id: 'dark', label: 'Dark Theme' },
    { id: 'professor', label: 'Professor Theme' }
  ];

  onBannerSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input && input.files && input.files.length ? input.files[0] : null;
    this.bannerFileName = file ? file.name : '';
  }
}
